import { type Common } from '../common.js';
import { ORGANIZATION_ID_HEADER_KEY } from './constants.js';
import {
  type CreateTransformationOptions,
  type Transformation,
  type TransformationDefinition,
  type TransformationValidationResult,
} from '../models/resourceGateway/transformation.js';

export interface ValidateTransformationOptions {
  transformationDefinition: TransformationDefinition;
}

export class API {
  common: Common;
  baseEndpoint = '/resource-gateway/integration-gateway/transformations';

  constructor(common: Common) {
    this.common = common;
  }

  async validate(options: ValidateTransformationOptions): Promise<TransformationValidationResult> {
    const url = this.common.constructPath(`${this.baseEndpoint}/validate`);
    return await this.common.postJSON(url, options);
  }

  async create(options: CreateTransformationOptions): Promise<{ transformation: Transformation }> {
    const { organizationId, name, transformationDefinition } = options;
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.fetchJsonWithCustomHeaders({
      url,
      method: 'POST',
      body: { name, transformationDefinition },
      headers: { [ORGANIZATION_ID_HEADER_KEY]: organizationId },
    });
  }
}
